import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Video, Bell, ListVideo, Users, Clock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { format, parseISO } from 'date-fns';

import { announcementsAPI } from '../services/api';

const ActivityFeed = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadActivities();
    }, []);

    const loadActivities = async () => {
        try {
            setLoading(true);

            // Fetch recent announcements
            const announcementsRes = await announcementsAPI.dashboard(5);
            const announcements = announcementsRes.data;

            // Format as activity items
            const activityItems = [
                ...announcements.map(a => ({
                    type: 'announcement',
                    icon: Bell,
                    color: 'text-yellow-500',
                    message: a.title,
                    timestamp: a.created_at,
                    link: '/notes'
                }))
            ];

            // Sort by timestamp
            activityItems.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

            setActivities(activityItems.slice(0, 10));
        } catch (error) {
            console.error('Failed to load activities:', error);
        } finally {
            setLoading(false);
        }
    };

    const getActivityIcon = (type) => {
        const icons = {
            video: Video,
            announcement: Bell,
            playlist: ListVideo,
            member: Users
        };
        return icons[type] || Bell;
    };

    if (loading) {
        return (
            <Card className="bg-[#1a1a1b] border-gray-800">
                <CardContent className="p-6">
                    <div className="flex items-center justify-center py-8">
                        <div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                    </div>
                </CardContent>
            </Card>
        );
    }

    return (
        <Card className="bg-[#1a1a1b] border-gray-800">
            <CardHeader className="border-b border-gray-800">
                <CardTitle className="text-white flex items-center gap-2">
                    <Clock className="w-5 h-5 text-purple-400" />
                    Son Gelişmeler
                </CardTitle>
            </CardHeader>
            <CardContent className="p-6">
                {activities.length === 0 ? (
                    <p className="text-center text-gray-500 py-8">Henüz güncelleme yok</p>
                ) : (
                    <div className="space-y-3">
                        {activities.map((activity, index) => {
                            const Icon = getActivityIcon(activity.type);

                            return (
                                <div
                                    key={index}
                                    onClick={() => activity.link && navigate(activity.link)}
                                    className="p-3 bg-[#0a0a0b] rounded-lg border border-gray-800 hover:border-gray-700 cursor-pointer transition-colors"
                                >
                                    <div className="flex items-start gap-3">
                                        <div className={`p-2 rounded-lg bg-gray-800/50 ${activity.color}`}>
                                            <Icon className="w-4 h-4" />
                                        </div>
                                        <div className="flex-1">
                                            <p className="text-white text-sm">{activity.message}</p>
                                            <p className="text-xs text-gray-500 mt-1">
                                                {format(parseISO(activity.timestamp), 'dd MMM, HH:mm')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </CardContent>
        </Card>
    );
};

export default ActivityFeed;
